import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ClaimDashboardService } from '../services/claim-v2-dashboard.service';
import {
  ClaimDashboardActionTypes,
  LoadClaimV2DashboardFail,
  LoadClaimV2DashboardSuccess
} from './claim-v2-dashboard.actions';
import { DashboardClaimV2 } from './claim-v2-dashboard.models';

export const loadDashboardClaimsEffect = createEffect(
  (actions$ = inject(Actions), claimDashboardService = inject(ClaimDashboardService)) => {
    return actions$.pipe(
      ofType(ClaimDashboardActionTypes.LOAD_CLAIM_V2_DASHBOARD),
      switchMap(() =>
        claimDashboardService.getDashboardClaims().pipe(
          map((response: DashboardClaimV2[]) => {
            return LoadClaimV2DashboardSuccess(response);
          }),
          catchError(error => of(LoadClaimV2DashboardFail(error)))
        )
      )
    );
  },
  { functional: true }
);
